import React from 'react'
import ChargebackTemplate from '../ChargebacksTemplate/ChargebackTemplate'

const AllChargeback = () => {
    return (
        <div>
            <ChargebackTemplate title='All Chargebacks' />

        </div>
    )
}

export default AllChargeback
